import { fetchResourceListConfig } from "src/system/fetchResourceListConfig.tsx";
import type { ClientConfig } from "src/client-config/getClientConfig.ts";

export const resourceListConfigQuery = ({
  resource,
  clientConfig,
}: {
  resource: string;
  clientConfig: ClientConfig;
}) => ({
  queryKey: ["listConfig", resource, clientConfig],
  queryFn: async () => {
    return await fetchResourceListConfig({
      resource,
      clientConfig,
    });
  },
});
